export function initVideoCarousel() {
    const carousel = document.querySelector('.video-carousel-container');
    if (!carousel)
        return;
    const track = carousel.querySelector('.video-carousel__track');
    const items = carousel.querySelectorAll('.video-carousel__item');
    const prevBtn = carousel.querySelector('.video-carousel__nav--prev');
    const nextBtn = carousel.querySelector('.video-carousel__nav--next');
    if (!track || items.length === 0)
        return;
    let currentIndex = 0;
    function getItemsToShow() {
        if (window.innerWidth < 576)
            return 1;
        if (window.innerWidth < 768)
            return 2;
        if (window.innerWidth < 992)
            return 3;
        return 4;
    }
    function updateCarousel() {
        const itemWidth = items[0].offsetWidth;
        const gap = 16;
        track.style.transform = `translateX(-${currentIndex * (itemWidth + gap)}px)`;
    }
    function getMaxIndex() {
        return Math.max(0, items.length - getItemsToShow());
    }
    prevBtn === null || prevBtn === void 0 ? void 0 : prevBtn.addEventListener('click', () => {
        currentIndex = Math.max(0, currentIndex - 1);
        updateCarousel();
    });
    nextBtn === null || nextBtn === void 0 ? void 0 : nextBtn.addEventListener('click', () => {
        currentIndex = Math.min(getMaxIndex(), currentIndex + 1);
        updateCarousel();
    });
    window.addEventListener('resize', () => {
        currentIndex = 0;
        updateCarousel();
    });
}
function getYouTubeEmbedUrl(url) {
    const patterns = [
        /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/,
        /youtube\.com\/v\/([a-zA-Z0-9_-]{11})/,
    ];
    for (const pattern of patterns) {
        const match = url.match(pattern);
        if (match) {
            return `https://www.youtube.com/embed/${match[1]}`;
        }
    }
    return null;
}
export function initVideoPopup() {
    const popup = document.getElementById('videoPopup');
    const container = document.getElementById('videoPopupContainer');
    const closeBtn = popup === null || popup === void 0 ? void 0 : popup.querySelector('.video-popup__close');
    const overlay = popup === null || popup === void 0 ? void 0 : popup.querySelector('.video-popup__overlay');
    const videoItems = document.querySelectorAll('.video-carousel__item');
    if (!popup || !container)
        return;
    videoItems.forEach((item) => {
        item.addEventListener('click', () => {
            const type = item.dataset.videoType;
            container.innerHTML = ''; // Clear previous content
            if (type === 'upload') {
                // Inject the block video player HTML
                const playerHtml = item.dataset.videoPlayer;
                const orientation = item.dataset.videoOrientation;
                container.classList.remove('is-portrait', 'is-landscape');
                if (orientation) {
                    container.classList.add(`is-${orientation}`);
                }
                if (playerHtml) {
                    container.innerHTML = playerHtml;
                    // Optionally, autoplay the video
                    const video = container.querySelector('video');
                    if (video) {
                        video.currentTime = 0;
                        video.play();
                    }
                }
            }
            else if (type === 'embed') {
                // Inject an iframe for oEmbed
                const embedUrl = item.dataset.videoUrl;
                container.classList.remove('is-landscape', 'is-portrait');
                if (embedUrl) {
                    const autoplayUrl = embedUrl.includes('?')
                        ? `${embedUrl}&autoplay=1`
                        : `${embedUrl}?autoplay=1`;
                    container.innerHTML = `<iframe src="${autoplayUrl}" frameborder="0" allowfullscreen allow="autoplay" style="width:100%;height:100%"></iframe>`;
                }
            }
            popup.classList.add('is-open');
            document.body.classList.add('popup-open');
        });
    });
    function closePopup() {
        if (!popup || !container)
            return;
        popup.classList.remove('is-open');
        document.body.classList.remove('popup-open');
        // Stop video/audio playback
        container.innerHTML = '';
    }
    closeBtn === null || closeBtn === void 0 ? void 0 : closeBtn.addEventListener('click', closePopup);
    overlay === null || overlay === void 0 ? void 0 : overlay.addEventListener('click', closePopup);
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && popup.classList.contains('is-open')) {
            closePopup();
        }
    });
}
